export enum CurrencyExchangeDirection {
  Sell = 'sell',
  Buy = 'buy',
}
